import React from 'react';
import { connect } from 'react-redux';
import round from 'lodash/round';
import pick from 'lodash/pick';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import units from '../../../lib/units';
import s from '../../../redux/selectors';
import a from '../../../redux/actions';
import types from '../../../types';
import { wrap, withT } from '../../../lib/wrappers';

const flightLevels = {
  short: (isMetric, t) => {
    const high = isMetric ? round(units.miToKm(400), -1) : 400;
    const unit = isMetric ? t('km/yr', { ns: 'units' }) : t('mi/yr', { ns: 'units' });
    return t('Short (< {{high}} {{unit}})', { high, unit });
  },
  medium: (isMetric, t) => {
    const low = isMetric ? round(units.miToKm(400), -1) : 400;
    const high = isMetric ? round(units.miToKm(1500), -1) : 1500;
    const unit = isMetric ? t('km/yr', { ns: 'units' }) : t('mi/yr', { ns: 'units' });
    return t('Medium ({{low}} - {{high}} {{unit}})', { low, high, unit });
  },
  long: (isMetric, t) => {
    const low = isMetric ? round(units.miToKm(1500), -1) : 1500;
    const high = isMetric ? round(units.miToKm(3000), -1) : 3000;
    const unit = isMetric ? t('km/yr', { ns: 'units' }) : t('mi/yr', { ns: 'units' });
    return t('Long ({{low}} - {{high}} {{unit}})', { low, high, unit });
  },
  extended: (isMetric, t) => {
    const low = isMetric ? round(units.miToKm(3000), -1) : 3000;
    const unit = isMetric ? t('km/yr', { ns: 'units' }) : t('mi/yr', { ns: 'units' });
    return t('Extended (> {{low}} {{unit}})', { low, unit });
  },
};

const Simple = ({
  t,
  isMetric,
  updateNumericInput,
  inputFootprintTransportationBus,
  inputFootprintTransportationTransit,
  inputFootprintTransportationCommuter,
  inputFootprintTransportationIntercity,
  inputFootprintTransportationAirshort,
  inputFootprintTransportationAirmedium,
  inputFootprintTransportationAirlong,
  inputFootprintTransportationAirextended,
}) => (
  <div>
    <div className="panel panel-default">
      <div className="panel-heading">{t('Public Transit')}</div>
      <div className="panel-body">
        <div className="cc-component__question">
          <h5>{t('Bus')}</h5>
          <div className="input-group">
            <input
              aria-label={isMetric ? t('km/yr', { ns: 'units' }) : t('mi/yr', { ns: 'units' })}
              className="form-control"
              onChange={e =>
                  updateNumericInput({ transportation_bus: e.target.value })
                }
              value={inputFootprintTransportationBus.inputDisplay}
              placeholder={inputFootprintTransportationBus.defaultDisplay}
            />
            <span className="input-group-addon">{isMetric ? t('km/yr', { ns: 'units' }) : t('mi/yr', { ns: 'units' })}</span>
          </div>
        </div>

        <div className="cc-component__question">
          <h5>{t('Transit Rail (light & heavy)')}</h5>
          <div className="input-group">
            <input
              aria-label={isMetric ? t('km/yr', { ns: 'units' }) : t('mi/yr', { ns: 'units' })}
              className="form-control"
              onChange={e =>
                  updateNumericInput({ transportation_transit: e.target.value })
                }
              value={inputFootprintTransportationTransit.inputDisplay}
              placeholder={inputFootprintTransportationTransit.defaultDisplay}
            />
            <span className="input-group-addon">{isMetric ? t('km/yr', { ns: 'units' }) : t('mi/yr', { ns: 'units' })}</span>
          </div>
        </div>

        <div className="cc-component__question">
          <h5>{t('Commuter Rail')}</h5>
          <div className="input-group">
            <input
              aria-label={isMetric ? t('km/yr', { ns: 'units' }) : t('mi/yr', { ns: 'units' })}
              className="form-control"
              onChange={e =>
                  updateNumericInput({ transportation_commuter: e.target.value })
                }
              value={inputFootprintTransportationCommuter.inputDisplay}
              placeholder={inputFootprintTransportationCommuter.defaultDisplay}
            />
            <span className="input-group-addon">{isMetric ? t('km/yr', { ns: 'units' }) : t('mi/yr', { ns: 'units' })}</span>
          </div>
        </div>

        <div className="cc-component__question">
          <h5>{t('Inter-city Rail (Amtrak)')}</h5>
          <div className="input-group">
            <input
              aria-label={isMetric ? t('km/yr', { ns: 'units' }) : t('mi/yr', { ns: 'units' })}
              className="form-control"
              onChange={e =>
                  updateNumericInput({ transportation_intercity: e.target.value })
                }
              value={inputFootprintTransportationIntercity.inputDisplay}
              placeholder={inputFootprintTransportationIntercity.defaultDisplay}
            />
            <span className="input-group-addon">{isMetric ? t('km/yr', { ns: 'units' }) : t('mi/yr', { ns: 'units' })}</span>
          </div>
        </div>
      </div>
    </div>
    <div className="panel panel-default">
      <div className="panel-heading">{t('Air Travel')}</div>
      <div className="panel-body">
        <div className="cc-component__question">
          <h5>{flightLevels.short(isMetric, t)}</h5>
          <div className="input-group">
            <input
              aria-label={t('flights/year')}
              className="form-control"
              onChange={e =>
                  updateNumericInput({ transportation_airshort: e.target.value })
                }
              value={inputFootprintTransportationAirshort.inputDisplay}
              placeholder={inputFootprintTransportationAirshort.defaultDisplay}
            />
            <span className="input-group-addon">{t('flights/year')}</span>
          </div>
        </div>

        <div className="cc-component__question">
          <h5>{flightLevels.medium(isMetric, t)}</h5>
          <div className="input-group">
            <input
              aria-label={t('flights/year')}
              className="form-control"
              onChange={e =>
                  updateNumericInput({ transportation_airmedium: e.target.value })
                }
              value={inputFootprintTransportationAirmedium.inputDisplay}
              placeholder={inputFootprintTransportationAirmedium.defaultDisplay}
            />
            <span className="input-group-addon">{t('flights/year')}</span>
          </div>
        </div>

        <div className="cc-component__question">
          <h5>{flightLevels.long(isMetric, t)}</h5>
          <div className="input-group">
            <input
              aria-label={t('flights/year')}
              className="form-control"
              onChange={e =>
                  updateNumericInput({ transportation_airlong: e.target.value })
                }
              value={inputFootprintTransportationAirlong.inputDisplay}
              placeholder={inputFootprintTransportationAirlong.defaultDisplay}
            />
            <span className="input-group-addon">{t('flights/year')}</span>
          </div>
        </div>

        <div className="cc-component__question">
          <h5>{flightLevels.extended(isMetric, t)}</h5>
          <div className="input-group">
            <input
              aria-label={t('flights/year')}
              className="form-control"
              onChange={e =>
                  updateNumericInput({ transportation_airextended: e.target.value })
                }
              value={inputFootprintTransportationAirextended.inputDisplay}
              placeholder={inputFootprintTransportationAirextended.defaultDisplay}
            />
            <span className="input-group-addon">{t('flights/year')}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  );

Simple.propTypes = {
  t: PropTypes.func.isRequired,
  isMetric: PropTypes.bool.isRequired,
  updateNumericInput: PropTypes.func.isRequired,
  inputFootprintTransportationBus: types.UserInput.isRequired,
  inputFootprintTransportationTransit: types.UserInput.isRequired,
  inputFootprintTransportationCommuter: types.UserInput.isRequired,
  inputFootprintTransportationIntercity: types.UserInput.isRequired,
  inputFootprintTransportationAirshort: types.UserInput.isRequired,
  inputFootprintTransportationAirmedium: types.UserInput.isRequired,
  inputFootprintTransportationAirlong: types.UserInput.isRequired,
  inputFootprintTransportationAirextended: types.UserInput.isRequired,
};
const mapStateToProps = (state, ownProps) => [
  'isMetric',
  'inputFootprintTransportationBus',
  'inputFootprintTransportationTransit',
  'inputFootprintTransportationCommuter',
  'inputFootprintTransportationIntercity',
  'inputFootprintTransportationAirshort',
  'inputFootprintTransportationAirmedium',
  'inputFootprintTransportationAirlong',
  'inputFootprintTransportationAirextended',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});

const mapDispatchToProps = dispatch => bindActionCreators(
  pick(a, [
    'updateNumericInput',
  ]),
  dispatch,
);

export default wrap(
  withT('travel'),
  connect(mapStateToProps, mapDispatchToProps)(Simple),
);
